import { CurationItem } from "../../types";
import { callCurationProxy } from "../backend/backendClient";
import { getPublisherId } from "../auth/authClient";

const MENU_CREATE_PATH = "/list/?index=0&copyImagePack=true";

export const getRequiredPublisherId = (): string => {
    const publisherId = getPublisherId();
    if (!publisherId) {
        throw new Error(
            "Publisher ID is missing from authentication cookies. Please log in again.",
        );
    }
    return publisherId;
};

/**
 * Creates a new menu container
 * @param parentId
 * @param publisherId
 * @param descriptor
 * @returns {Promise<CurationItem>}
 */
export const createMenuContainer = async (
    parentId: string,
    publisherId: string,
    descriptor: "Header" | "Footer" | "Menu",
): Promise<CurationItem> => {
    const createBody = [
        {
            contentType: "menu",
            parentId,
            metadata: {
                default: { "publisher-id": publisherId },
                en_US: {},
            },
        },
    ];

    const createRes = await callCurationProxy({
        path: MENU_CREATE_PATH,
        method: "POST",
        body: createBody,
    });

    const createResponseText = await createRes.text();
    if (!createRes.ok) {
        throw new Error(`POST Error for ${descriptor}: ${createRes.status}, ${createResponseText}`);
    }

    const creationData = JSON.parse(createResponseText) as { result?: CurationItem[] };
    const newMenu = creationData.result?.[0];

    if (!newMenu?.id) {
        throw new Error(
            `API Error: ${descriptor} created but no ID was returned. Response: ${createResponseText}`,
        );
    }

    return newMenu;
};

/**
 * Updates a menu container
 * @param menuId
 * @param updateBody
 * @param descriptor
 * @returns {Promise<void>}
 */
export const updateMenuContainer = async (
    menuId: number,
    updateBody: CurationItem,
    descriptor: "Header" | "Footer" | "Menu",
): Promise<void> => {
    const updateRes = await callCurationProxy({
        path: `/list/${menuId}`,
        method: "PUT",
        body: updateBody,
    });

    const updateResponseText = await updateRes.text();
    if (!updateRes.ok) {
        throw new Error(`PUT Error for ${descriptor}: ${updateRes.status}, ${updateResponseText}`);
    }
};
